<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content contact-section background-light">
			<div class="row contact-form-row">
				<div class="columns column5 contact-form-col">
					<contact-form v-if="form" name="wedding" :form="form" />
				</div>
			</div>
			<div class="fine-bg-pattern" />
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();
useRemoveGifty();

const { data: form } = await useWebsiteFetch('wedding', {
	query: { language: locale.value },
	key: `${locale.value}/wedding`,
});
</script>

<style scoped lang="scss">
.background-light {
	background-color: #c79a95;
	position: relative;
}

.fine-bg-pattern {
	position: absolute;
	inset: 0;
	width: 100%;
	z-index: 1;
	opacity: 0.3;
}

.contact-form-row {
	position: relative;
	z-index: 2;
}

:deep(h1) {
	color: #c79a95;
}

.contact-form-col {
	margin: auto;
}

@media (max-width: 900px) {
	.contact-section {
		padding-top: 0;
	}

	.main-content#intro {
		padding-bottom: 15px;
	}
}
</style>
